import styled from 'styled-components'
import {rem} from 'src/utils'

export default styled.h3`
  margin-top: -20px;
  padding: ${rem(5)} 0;
  border: 7px solid #333;
  border-left: 0;
  border-right: 0;
`
